// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3caN9","signatureButtonsRight":"ModalSign_signatureButtonsRight__3mXg2"};